



























































































































































































































import { Component, Vue } from "vue-property-decorator";
import { addMonths, format } from "date-fns";
import {
  getAllProjectSalesReport,
  getSalesReportCSV,
  getPresets,
  savePreset,
  deletePreset,
  getServiceProjectCompanies,
  getServiceProjectResponsibleStaffs,
  GetAllProjectSalesReportQuery
} from "../../api/sales-report-api";
import SalesReportSales from "../components/SalesReportSales.vue";
import SalesReportMonthlyChart from "../components/SalesReportMonthlyChart.vue";
import SalesReportMonthlySummary from "../components/SalesReportMonthlySummary.vue";
import ExpensesGraphSaleReport from "../components/ExpensesGraphSaleReport.vue";
import VToolbar from "@/components/V-Toolbar.vue";
import VIconPrev from "../components/VIconPrev.vue";
import VIconNext from "../components/VIconNext.vue";
import SalesReportSummary from "../components/SalesReportSummary.vue";
import SelectOption from "@/common/ui/presenters/select-option";
import { getExpenseCategories } from "@/api/cost/expense-categories-api";
import PresetCreateModal from "@/sales/ui/components/PresetCreateModal.vue";
import PresetDeleteModal from "@/sales/ui/components/PresetDeleteModal.vue";
import PresetFormData from "@/api/models/PresetFormData";
import IPresetOutput from "@/api/models/IPresetOutput";
import { debounce } from "lodash";

@Component({
  components: {
    VToolbar,
    VIconPrev,
    VIconNext,
    SalesReportSummary,
    SalesReportMonthlyChart,
    SalesReportMonthlySummary,
    SalesReportSales,
    ExpensesGraphSaleReport,
    PresetCreateModal,
    PresetDeleteModal
  }
})
export default class SalesReportAllProjectPage extends Vue {
  formatter = Intl.NumberFormat("ja-JP", {
    style: "currency",
    currency: "JPY"
  });

  companyTypeOptions: SelectOption[] = [
    { text: "全ての事業形態", value: "" },
    { text: "法人", value: "1" },
    { text: "個人", value: "2" },
    { text: "エンドユーザー", value: "3" }
  ];
  monthOptions: SelectOption[] = [
    { text: "期間", value: "" },
    { text: "1ヶ月間", value: "1" },
    { text: "2ヶ月間", value: "2" },
    { text: "3ヶ月間", value: "3" },
    { text: "4ヶ月間", value: "4" },
    { text: "5ヶ月間", value: "5" },
    { text: "6ヶ月間", value: "6" },
    { text: "7ヶ月間", value: "7" },
    { text: "8ヶ月間", value: "8" },
    { text: "9ヶ月間", value: "9" },
    { text: "10ヶ月間", value: "10" },
    { text: "11ヶ月間", value: "11" },
    { text: "12ヶ月間", value: "12" }
  ];
  staffOptions: SelectOption[] = [{ text: "自社責任者", value: "" }];
  vendorOptions: SelectOption[] = [{ text: "全ての発注先", value: "" }];
  expenseCategoryOptions: SelectOption[] = [{ text: "経費項目", value: "" }];
  presetOptions: SelectOption[] = [{ text: "なし", value: "" }];
  clientOptions: SelectOption[] = [{ text: "全ての発注者", value: "" }];
  presets: IPresetOutput[] = [];
  selectedPresetId = "";

  data = {
    project: null as any,
    estimates: [] as any[],
    purchases: [] as any[],
    invoices: [] as any[],
    performance: {} as any
  };

  report = {} as any;
  monthly = {
    labels: [] as string[],
    invoices: [] as number[],
    purchases: [] as number[],
    profits: [] as number[]
  };

  taxExcluded: boolean = true;
  graphOption = "1";
  graphOptions = [
    { text: "発注金額", value: "1" },
    { text: "利益額", value: "2" },
    { text: "値引き額", value: "3" },
    { text: "利益率", value: "4" }
  ];
  graphFormatter = 1;

  query: GetAllProjectSalesReportQuery = {
    month: "",
    monthOptions: "",
    companyType: "",
    clientId: "",
    staffId: "",
    vendorId: "",
    expenseCategoryId: ""
  };

  month: Date | undefined;
  monthLabel = "";
  disablePrevMonth = true;

  protected async created() {
    if (this.$store.state.service.createdDate) {
      const createdDate = new Date(this.$store.state.service.createdDate);
      this.monthLabel = format(createdDate, "yyyy年MM月") + " ～ 現時点";
    }
    await this.initClientList();
    await this.initVendorList();
    await this.initStaffList();
    await this.initExpenseCategories();
    await this.initPresets();

    await this.searchGraph();
  }

  search = debounce(async () => {
    this.taxExcluded = true;
    this.graphOption = "1";
    await this.searchGraph();
  }, 500);

  private async searchGraph() {
    const report = await getAllProjectSalesReport({
      ...this.query,
      month: this.disablePrevMonth
        ? ""
        : this.month
        ? format(this.month, "yyyy-MM")
        : ""
    });
    this.report = report;
  }

  async researchClientOptions() {
    await this.initClientList();
    await this.search();
  }

  private async initClientList() {
    this.query.clientId = "";
    this.clientOptions = [{ text: "全ての発注者", value: "" }];
    const companies = await getServiceProjectCompanies({
      type: "client",
      companyType: this.query.companyType
    });
    companies.map((company: any) =>
      this.clientOptions.push({
        value: company.id,
        text: company.name
      })
    );
  }

  private async initVendorList() {
    const companies = await getServiceProjectCompanies({
      type: "vendor"
    });
    companies.map((company: any) =>
      this.vendorOptions.push({
        value: company.office.id,
        text: company.name
      })
    );
  }

  private async initStaffList() {
    const staffs = await getServiceProjectResponsibleStaffs();
    staffs.map((staff: any) =>
      this.staffOptions.push({
        value: staff.id,
        text: staff.name
      })
    );
  }

  private async initExpenseCategories() {
    const expenseCategories = await getExpenseCategories();
    expenseCategories.map(category => {
      if (category.name !== "値引き") {
        this.expenseCategoryOptions.push({
          value: category.id,
          text: category.name
        });
      }
    });
  }

  private async initPresets() {
    this.presets = await getPresets();
    this.presetOptions = [];
    this.presetOptions.push({ text: "なし", value: "" });
    this.presets.map((preset: any) => {
      this.presetOptions.push({
        value: preset.id,
        text: preset.name
      });
    });
  }

  private resetPreset() {
    this.query.companyType = "";
    this.query.clientId = "";
    this.query.vendorId = "";
    this.query.staffId = "";
    this.query.expenseCategoryId = "";
    this.query.monthOptions = "";
  }

  async changePresetOption() {
    if (this.selectedPresetId) {
      const preset = this.presets.find(
        item => item.id === this.selectedPresetId
      );

      if (preset) {
        this.query.companyType = preset.companyType ? preset.companyType : "";
        this.query.clientId = preset.clientId ? preset.clientId : "";
        this.query.vendorId = preset.vendorId ? preset.vendorId : "";
        this.query.staffId = preset.staffId ? preset.staffId : "";
        this.query.expenseCategoryId = preset.expenseCategoryId
          ? preset.expenseCategoryId
          : "";
      }
    } else {
      this.resetPreset();
    }
    await this.search();
  }

  async createPreset(presetName: string) {
    const form = PresetFormData({
      id: "",
      name: presetName,
      serviceId: this.$store.state.serviceId,
      companyType: this.query.companyType ? this.query.companyType : "",
      clientId: this.query.clientId ? this.query.clientId : "",
      vendorId: this.query.vendorId ? this.query.vendorId : "",
      staffId: this.query.staffId ? this.query.staffId : "",
      expenseCategoryId: this.query.expenseCategoryId
        ? this.query.expenseCategoryId
        : ""
    });
    const presetId = await savePreset(form);
    await this.initPresets();
    this.selectedPresetId = presetId;
    alert("保存しました。");
  }

  async deletePreset() {
    if (this.selectedPresetId) {
      await deletePreset(this.selectedPresetId);
      alert("削除されました。");
      this.initPresets();
      this.selectedPresetId = "";
      this.resetPreset();
      await this.search();
    }
  }

  async exportCSV() {
    const response = await getSalesReportCSV({
      ...this.query
    });
    if (response.file) {
      window.open(response.file);
    }
  }

  get reportSummary() {
    if (this.report.summary) {
      return this.taxExcluded
        ? this.report.summary.excludedTax
        : this.report.summary.includedTax;
    }
    return {};
  }

  get expenseCategoriesLabel() {
    if (this.report.expenses) {
      let tempExpenses = this.report.expenses;
      if (this.graphOption === "1") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.orderAmount) !== 0
        );
      }

      if (this.graphOption === "2") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.profitAmount) !== 0
        );
      }

      if (this.graphOption === "3") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.discountAmount) !== 0
        );
      }

      if (this.graphOption === "4") {
        tempExpenses = tempExpenses.filter(
          (item: any) => Number(item.profitRate) !== 0
        );
      }

      return tempExpenses.map((item: any) => item.categoryName);
    }
    return [];
  }

  get expenseCategoriesValue() {
    this.graphFormatter = 1;
    if (this.report.expenses) {
      if (this.graphOption === "1") {
        return this.report.expenses
          .filter((item: any) => Number(item.orderAmount) !== 0)
          .map((item: any) => item.orderAmount);
      }

      if (this.graphOption === "2") {
        return this.report.expenses
          .filter((item: any) => Number(item.profitAmount) !== 0)
          .map((item: any) => item.profitAmount);
      }

      if (this.graphOption === "3") {
        return this.report.expenses
          .filter((item: any) => Number(item.discountAmount) !== 0)
          .map((item: any) => item.discountAmount);
      }

      if (this.graphOption === "4") {
        this.graphFormatter = 2;
        return this.report.expenses
          .filter((item: any) => Number(item.profitRate) !== 0)
          .map((item: any) => item.profitRate);
      }
    }
    return [];
  }

  get expenseGraphFormatter() {
    return this.graphFormatter;
  }

  async movePrevMonth() {
    if (this.month) {
      await this.search();
      const createdDate = new Date(this.$store.state.service.createdDate);
      const equalCreatedDate =
        this.month.getMonth() === createdDate.getMonth() &&
        this.month.getFullYear() === createdDate.getFullYear();
      if (equalCreatedDate) {
        this.month = undefined;
        this.monthLabel = format(createdDate, "yyyy年MM月") + " ～ 現時点";
      } else {
        this.month = addMonths(this.month, -1);
        this.monthLabel = format(this.month, "yyyy年MM月");
      }
      this.disablePrevMonth = equalCreatedDate;
      await this.search();
    }
  }

  async moveNextMonth() {
    this.disablePrevMonth = false;
    if (!this.month) {
      const createdDate = new Date(this.$store.state.service.createdDate);
      this.month = createdDate;
    } else {
      this.month = addMonths(this.month, 1);
    }
    this.monthLabel = format(this.month, "yyyy年MM月");
    await this.search();
  }

  showModalCreate() {
    (this.$refs.presetCreateModal as any).show();
  }

  showModalDelete() {
    (this.$refs.presetDeleteModal as any).show();
  }

  formatCurrency(value: any) {
    return value || value === 0 ? "￥" + Number(value).toLocaleString() : "";
  }

  isEmptyPieChart() {
    return this.expenseCategoriesValue.every((item: any) => Number(item) === 0);
  }

  isNegative(value: any) {
    return Number(value) < 0;
  }
}
